/**
 * iconMap
 * Explicit map of every Lucide icon name used in resourceData.
 *
 * Why this exists instead of `import * as LucideIcons`:
 * A wildcard import prevents tree-shaking from eliminating the hundreds of
 * unused icons in the Lucide library. This map imports only what we actually
 * use, keeping the bundle lean.
 *
 * When you add a new icon name to resources.js, add the corresponding import
 * and entry here.
 */
import {
  Ban,
  BookMarked,
  BookOpen,
  Box,
  Brain,
  Briefcase,
  Brush,
  Camera,
  Clapperboard,
  Code2,
  Compass,
  Cuboid,
  DollarSign,
  FileSignature,
  FileText,
  Film,
  Gamepad2,
  GalleryHorizontal,
  Ghost,
  Globe,
  GraduationCap,
  Image,
  Layout,
  LayoutDashboard,
  LayoutTemplate,
  Layers,
  Lightbulb,
  ListChecks,
  MessageCircle,
  Palette,
  PenTool,
  Receipt,
  RefreshCw,
  Rocket,
  Ruler,
  Scissors,
  ShoppingBag,
  Spline,
  Star,
  Sun,
  Tag,
  Timer,
  Triangle,
  Type,
  Users,
  Video,
  Wand2,
  Waypoints,
  Zap,
  // Figma is not a standard Lucide icon name — falls back to emoji
} from 'lucide-react';

/** @type {Record<string, import('lucide-react').LucideIcon>} */
export const ICON_MAP = {
  Ban,
  BookMarked,
  BookOpen,
  Box,
  Brain,
  Briefcase,
  Brush,
  Camera,
  Clapperboard,
  Code2,
  Compass,
  Cuboid,
  DollarSign,
  FileSignature,
  FileText,
  Film,
  Gamepad2,
  GalleryHorizontal,
  Ghost,
  Globe,
  GraduationCap,
  Image,
  Layout,
  LayoutDashboard,
  LayoutTemplate,
  Layers,
  Lightbulb,
  ListChecks,
  MessageCircle,
  Palette,
  PenTool,
  Receipt,
  RefreshCw,
  Rocket,
  Ruler,
  Scissors,
  ShoppingBag,
  Spline,
  Star,
  Sun,
  Tag,
  Timer,
  Triangle,
  Type,
  Users,
  Video,
  Wand2,
  Waypoints,
  Zap,
};
